import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader

import Vue from "vue";
import VueLogger from "vuejs-logger";

// import de vue-cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// set default config
Vue.$cookies.config("7d");

// CSS
import "vue-multiselect/dist/vue-multiselect.min.css";
import "ag-grid-autocomplete-editor/main.css";

// Fontawesome
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

// VeeValidate
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
// loop over all rules
for (let rule in rules) {
  // add the rule
  extend(rule, rules[rule]);
}
import fr from "vee-validate/dist/locale/fr.json";
localize("fr", fr);

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

//Vuetify
import vuetify from "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

import "@/assets/animate.scss";

import "@/main.scss";

// Vue de base
import App from "./app/App.vue";

// Vue Signature Pad
// import VueSignature from "vue-signature-pad";
// Vue.use(VueSignature);

import "@/app/shared/services/registerServiceWorker";
import router from "@/app/app-routes";
import store from "@/app/app-state";
import services from "@/app/app-services";

// JS
import "vue-multiselect/dist/vue-multiselect.min.js";

//cilent id -> site de connexion

import { logLevel } from "@/environment/environment";

Vue.config.productionTip = false;

const options = {
  isEnabled: true,
  logLevel: logLevel,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};
Vue.use(VueLogger, options);

import test from "./directives/test.js";
Vue.directive("test", test);

store
  .dispatch("userContext/initContextStateWithCookies")
  .then()
  .catch(err => {
    Vue.$log.error(err);
  })
  .finally(d => {
    services.start();

    Vue.$log.debug(d);

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  });
